import React from 'react'
import styled from 'styled'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"

import { TourList } from '../../store'

import { Tour } from 'generated/mos/org/getty/audio'

import { CategoryTourItem } from './category-tour-item'

import { bffEndpoint } from 'helpers/bff'
import { dndReorder } from 'helpers/drag-and-drop'
import { space } from 'helpers/style'

const DroppableContainer = styled.div`
  display: flex;
  overflow-x: scroll;
  flex-wrap: no-wrap;
  padding-left: ${space(5)};
`

const DraggableContainer = styled.div`
  flex: 0 0 auto;
  width: 260px;
  padding: ${space(3)};
`

type Props = {
  readonly tours: TourList | undefined;
  readonly orderedCategoryTours: ReadonlyArray<Tour.Ref>;
  readonly setOrderedCategoryTours: (toursRefs: ReadonlyArray<Tour.Ref>) => void;
};

export const ReorderableTours = ({ orderedCategoryTours, setOrderedCategoryTours, tours }: Props) => {
  const hostName = bffEndpoint(window.location.hostname)

 return (
   <DragDropContext onDragEnd={dropResult => setOrderedCategoryTours(dndReorder(dropResult, orderedCategoryTours))}>
     <Droppable droppableId="category-tours-list" direction="horizontal">
       {(provided) => (
         <DroppableContainer
           ref={provided.innerRef}
           {...provided.droppableProps}
          >
           {tours && orderedCategoryTours
            .map(ref => tours.filter(item => item.ref && item.ref.id === ref.id)[0])
            .map((tour, index) => {
              const id = tour.ref ? tour.ref.id : ''
              return (
                <Draggable draggableId={id} key={id} index={index} >
                  {(provided, snapshot) => (
                    <DraggableContainer
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <CategoryTourItem
                        tour={tour}
                        draggableIndex={index}
                        isDragging={snapshot.isDragging}
                        hostName={hostName}
                      />
                    </DraggableContainer>
                  )}
                </Draggable>
              )
            })}
           {provided.placeholder}
         </DroppableContainer>
        )}
     </Droppable>
   </DragDropContext>
  )
}
